export default [{
    path: 'orderlist',
    name: {list:['数字店铺','订单','订单管理','订单列表']},
    component: () => import('@/views/order/orderList.vue')
},{
    path: 'orderDetails',
    name: {list:['数字店铺','订单','订单管理','订单列表','订单详情'],title:'订单详情'},
    component: () => import('@/views/order/orderDetails.vue')
},{
    path: 'cancelRList',
    name: {list:['数字店铺','订单','订单管理','取消原因']},
    component: () => import('@/views/order/cancelRList.vue')
},{
    path: 'afterSalesList',
    name: {list:['数字店铺','订单','订单管理','售后类型',]},
    component: () => import('@/views/order/afterSalesList.vue')
},{
    path: 'refundOrderList',
    name: {list:['数字店铺','订单','订单管理','退单列表']},
    component: () => import('@/views/order/refundOrderList.vue')
},{
    path: 'refundOrderDetails',
    name: {list:['数字店铺','订单','订单管理','退单列表',],title:'退单详情'},
    component: () => import('@/views/order/refundOrderDetails.vue')
}]